import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

/** Errors are thrown with the backend's message so the page can show it. */
const messageOf = (error) =>
  error?.response?.data?.message || error?.response?.data?.error || error?.message || "Request failed";

export const listLoginPageCards = async () => {
  try {
    const response = await apiService.get(apiEndPoints.loginPageCards);
    return response?.data ?? [];
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const createLoginPageCard = async (card) => {
  try {
    return await apiService.post(apiEndPoints.loginPageCards, card);
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const updateLoginPageCard = async (id, card) => {
  try {
    return await apiService.update(`${apiEndPoints.loginPageCards}/${encodeURIComponent(id)}`, card);
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

export const deleteLoginPageCard = async (id) => {
  try {
    await apiService.delete(`${apiEndPoints.loginPageCards}/${encodeURIComponent(id)}`);
  } catch (error) {
    throw new Error(messageOf(error));
  }
};

/** Every persona, for the "Shown to" picker (the feature flags' persona list). */
export const listPersonaOptions = async () => {
  try {
    const response = await apiService.get(`${apiEndPoints.featureFlags}/scope-options?type=PERSONA&search=`);
    return (response?.data ?? []).map((option) => option.id);
  } catch (error) {
    throw new Error(messageOf(error));
  }
};
